interface ElearningResourceMetadataType {
  position: number;
  type: string;
  url: string;
}

// eslint-disable-next-line no-shadow
export enum ResourceMetadataType {
  PDF = 0,
  WORD = 1,
  EXCEL = 2,
  POWERPOINT = 3,
  LINK = 4,
}

/**
 * CloudFront signed-URL query triple issued once per launch for this course's
 * `pages/resources/*` folder. Appended verbatim to file resource links so they
 * open in a new tab without the player's signed cookies (LMS2-5136).
 */
export interface ResourceSignature {
  Policy: string;
  Signature: string;
  'Key-Pair-Id': string;
}

export interface ResourceType {
  id: string;
  name: string;
  elearningResourceMetadata: ElearningResourceMetadataType;
  tenantId?: string;
  elearning?: string;
  lcmsReferenceIds?: any;
  isDeleted?: boolean | null;
  createdAt?: Date;
  modifiedAt?: Date;
}
